import { Layers } from 'pages/pointClouds/components/layers/Layers'
import React, { useState } from 'react'
import styled from 'styled-components'

import { HudSettingsOverlayContainer } from './controlPanel/HudSettingsOverlayContainer'
import { HudPlusMenuOverlayContainer } from './HudPlusMenuOverlayContainer'
import { MiniInstructionsOverlay } from './MiniInstructionsOverlay'
import { HudObservationOverlayContainer } from './observationPanel/HudObservationOverlayContainer'
import { ObservationTooltipContent } from './observationPanel/ObservationTooltipContent'
import { PointCloudPopupMenus } from './PointCloudPopupMenus'
import { WhatAmILookingAt } from './WhatAmILookingAt'

const HudContainer = styled.div`
  position: absolute;
  top: 8px;
  right: 20px;
  bottom: 20px;
  left: 8px;
  z-index: 1000;
  pointer-events: none;
`

const SettingsSection = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  pointer-events: auto;
`

const ObservationSection = styled.div`
  position: absolute;
  top: 65px;
  left: 0;
  pointer-events: auto;
`

const PlusMenuSection = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  pointer-events: auto;
`

const LayersSection = styled.div`
  position: absolute;
  bottom: 10px;
  left: 10px;
`
const InstructionSection = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  pointer-events: auto;
`

const WAILASection = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  pointer-events: none;
  display: flex;
  justify-content: center;
`

export type OpenPanel = 'settings' | 'observations' | null

type HudProps = {
  orgId: string | undefined
  siteId: string
  pointCloudOrSceneId: string | undefined
}

export const Hud: React.FC<HudProps> = ({
  orgId,
  siteId,
  pointCloudOrSceneId,
}) => {
  const [openPanel, setOpenPanel] = useState<OpenPanel>(null)

  return (
    <>
      <HudContainer>
        <InstructionSection>
          <MiniInstructionsOverlay isVisible={true} />
        </InstructionSection>
        <WAILASection>
          <WhatAmILookingAt>
            <ObservationTooltipContent />
          </WhatAmILookingAt>
        </WAILASection>
        <SettingsSection>
          <HudSettingsOverlayContainer
            isOpen={openPanel === 'settings'}
            orgId={orgId}
            siteId={siteId}
            pointCloudOrSceneId={pointCloudOrSceneId}
            onToggle={(isOpen) => setOpenPanel(isOpen ? 'settings' : null)}
          />
        </SettingsSection>
        <ObservationSection>
          <HudObservationOverlayContainer
            isOpen={openPanel === 'observations'}
            onToggle={(isOpen) => setOpenPanel(isOpen ? 'observations' : null)}
          />
        </ObservationSection>
        <PlusMenuSection>
          <HudPlusMenuOverlayContainer />
        </PlusMenuSection>
      </HudContainer>
      <LayersSection>
        <Layers />
      </LayersSection>
      <PointCloudPopupMenus />
    </>
  )
}
